import { Controller } from "@hotwired/stimulus"

// Organizzazioni di pages/Piani.js: «Apri» mostra il dettaglio sotto la riga (Turbo Frame `dettaglio-org`), uno alla
// volta; lo stesso pulsante (con la X) lo chiude. Ogni apertura ricarica il dettaglio, come DettaglioOrg rimontato;
// finché arriva c'è la rotella. Una riga riscritta dopo un'azione (onCambio) resta quella aperta: si ricorda l'indirizzo
// del dettaglio, non il pulsante.
export default class extends Controller {
  static targets = ["riga", "cella", "attesa", "organizzazione"]

  apri({ currentTarget: pulsante, params: { url } }) {
    const giaAperto = this.url === url
    this.chiudi()
    if (giaAperto) return

    pulsante.closest("tr").after(this.rigaTarget)
    const frame = document.createElement("turbo-frame")
    frame.id = "dettaglio-org"
    frame.append(this.attesaTarget.content.cloneNode(true))
    frame.setAttribute("src", url)
    this.cellaTarget.replaceChildren(frame)
    this.rigaTarget.hidden = false
    this.segna(pulsante, true)
    this.url = url
  }

  chiudi() {
    const pulsante = this.pulsanteAperto
    if (pulsante) this.segna(pulsante, false)
    this.url = null
    this.cellaTarget.replaceChildren()
    this.rigaTarget.hidden = true
  }

  // la riga dell'organizzazione aperta riscritta dal server: il dettaglio resta sotto di lei
  organizzazioneTargetConnected(riga) {
    if (!this.url || !riga.querySelector(`[data-dettaglio-org-url-param="${this.url}"]`)) return
    if (riga.nextElementSibling !== this.rigaTarget) riga.after(this.rigaTarget)
  }

  get pulsanteAperto() {
    return this.url ? this.element.querySelector(`[data-dettaglio-org-url-param="${this.url}"]`) : null
  }

  segna(pulsante, aperto) {
    pulsante.querySelector("[data-chiusa]").hidden = aperto
    pulsante.querySelector("[data-aperta]").hidden = !aperto
  }
}
